import Service from '@/views/service'
import Search from '@/views/service/search/index'
import Geocoding from '@/views/service/geocoding'
import Location from '@/views/service/location'
import MapMatch from '@/views/service/mapMatch'
import RegionQuery from '@/views/service/regionQuery'
import PathPlan from '@/views/service/pathPlan'

export default {
  path: '/service',
  component: Service,
  meta: {
    title: '服务介绍'
  },
  children: [
    { path: '/service/search', component: Search },
    { path: '/service/geo', component: Geocoding },
    { path: '/service/regeo', component: Location },
    { path: '/service/mapmatch', component: MapMatch },
    { path: '/service/division', component: RegionQuery },
    { path: '/service/routing', component: PathPlan }
  ]
}
